import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import NavBar from '../NavBar';
import Footer from '../Footer';
import { useAuth } from '../../Authen/AuthContext';
import { useTranslation } from 'react-i18next';
import MapPicker from '../Map/MapPicker';
const EditProperty = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();
  const [property, setProperty] = useState(null);
  const { isAuthenticated, role } = useAuth();
  const [errors, setErrors] = useState({});
  const [newImages, setNewImages] = useState([]); // เก็บไฟล์ใหม่ก่อนอัพโหลด

  const [latLng, setLatLng] = useState({ lat: 7.8806, lng: 98.3923 });

// บนสุดของ component
const [removedImages, setRemovedImages] = useState([]); // ✅ เพิ่ม state สำหรับรูปที่ลบ

  const locations = [
    "Talat Yai","Talat Nuea","Koh Kaew","Ratsada","Wichit","Chalong",
    "Rawai","Karon","Kathu","Patong","Kamala","Thep Krasatti",
    "Srisunthorn","Cherng Talay","Paklok","Mai Khao","Sakhu",
  ];

  const requiredFields = [
    { field: 'name', label: t('Property Name') },
    { field: 'price', label: t('Price') },
    { field: 'location', label: t('Location') },
    { field: 'type', label: t('Type') },
    { field: 'status', label: t('Status') },
    { field: 'ownership', label: t('Ownership') },
  ];


 

  useEffect(() => {
    if (!isAuthenticated) navigate('/loginform');
    else if (role !== 'Admin') navigate('/');
  }, [isAuthenticated, role, navigate]);
  
  useEffect(() => {
  fetch(`https://summerhousagentlive.onrender.com/api/properties/${id}`)
    .then(res => res.json())
    .then(data => {
      setProperty({
        ...data,
        images: data.images || [],
        location: data.location || '',
        type: data.type || '',
        status: data.status || '',
        constructionStatus: data.constructionStatus || '',
        description: data.description || '',
      });

      // ✅ ถ้ามีพิกัดใน DB ให้เซ็ตลงใน latLng
      if (data.latitude && data.longitude) {
        setLatLng({ lat: parseFloat(data.latitude), lng: parseFloat(data.longitude) });
      }
    })
    .catch(err => console.error('Error fetching property:', err));
}, [id]);


  const validateForm = () => {
    const newErrors = {};
    requiredFields.forEach(({ field, label }) => {
      if (!property[field] || (field === 'images' && property.images?.length === 0)) {
        newErrors[field] = `${label} ${t('is required')}`;
      }
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setProperty(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
  };

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    setNewImages(files); // แทนที่ไฟล์เก่าใหม่ทั้งหมด
  };

  const handleRemoveImage = (idx) => {
    if (idx < property.images.length) {
      setProperty(prev => ({
        ...prev,
        images: prev.images.filter((_, i) => i !== idx)
      }));
    } else {
      const newIdx = idx - property.images.length;
      setNewImages(prev => prev.filter((_, i) => i !== newIdx));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    try {
      let uploadedImages = property.images;

      if (newImages.length > 0 || removedImages.length > 0) {
        const formData = new FormData();
        newImages.forEach(file => formData.append('images', file));
        formData.append('removedImages', JSON.stringify(removedImages));

        const resUpload = await fetch(`https://summerhousagentlive.onrender.com/api/properties/${id}`, {
          method: 'PUT',
          body: formData,
        });

        if (resUpload.ok) {
          const data = await resUpload.json();
          uploadedImages = data.property.images;
          setProperty(prev => ({ ...prev, images: uploadedImages }));
          setNewImages([]);
          setRemovedImages([]);
        } else {
          alert(t('Failed to upload images'));
          return;
        }
      }

      const propertyData = { 
        ...property, 
        images: uploadedImages,
        latitude: latLng.lat,
        longitude: latLng.lng,
        rental_end_date: property.rentalEndDate ? new Date(property.rentalEndDate) : null
      };

      const res = await fetch(`https://summerhousagentlive.onrender.com/api/properties/${id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(propertyData),
      });

      if (res.ok) {
        alert(t('Property updated successfully'));
        navigate('/dashboardadmin');
      } else {
        alert(t('Unable to update property'));
      }

    } catch (err) {
      console.error('Error updating:', err);
    }
  };


  if (!property) return <div>{t('Loading...')}</div>;

  return (
    <div >
      <NavBar />
      <div style={styles.container}>
        <h2 style={styles.heading}>{t('Edit Property')}</h2>
        <form onSubmit={handleSubmit} style={styles.form}>

          <label>{t('Property Name')}</label>
          <input
            type="text"
            name="name"
            value={property.name || ''}
            onChange={handleChange}
            placeholder={t('Property Name')}
            style={{...styles.input, borderColor: errors?.name ? 'red' : '#ddd'}}
          />
          {errors?.name && <div style={styles.error}>{errors.name}</div>}

          <label>{t('Price')}</label>
          <input
            type="text"
            name="price"
            value={property.price ? property.price.toLocaleString() : ''}
            onChange={(e)=>{
              const rawValue = e.target.value.replace(/,/g,'').trim();
              const numberValue = Number(rawValue);
              setProperty(prev => ({...prev, price: isNaN(numberValue) ? '' : numberValue}));
            }}
            placeholder={t('Price')}
            style={{...styles.input, borderColor: errors?.price ? 'red' : '#ddd'}}
          />
          {errors?.price && <div style={styles.error}>{errors.price}</div>}

          <label>{t('Images')}</label>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', marginTop: '10px' }}>
            {[...newImages.map(f => URL.createObjectURL(f)), ...property.images].map((imgUrl, idx) => (
              <div key={idx} style={{ position: 'relative', width: '100px', height: '100px' }}>
                <img
                  src={imgUrl}
                  alt={`Property ${idx}`}
                  style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '8px', border: '1px solid #ddd' }}
                />
                <button type="button" onClick={() => handleRemoveImage(idx)} style={{
                  position: 'absolute',
                  top: 0,
                  right: 0,
                  background: 'rgba(0,0,0,0.5)',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '50%',
                  width: '20px',
                  height: '20px',
                  cursor: 'pointer',
                }}>&times;</button>
              </div>
            ))}
            {property.images.length + newImages.length === 0 && <p>{t('No images uploaded')}</p>}
          </div>
          <input
            type="file"
            multiple
            accept="image/*"
            onChange={handleImageChange}
            style={{ marginTop: '10px' }}
          />
          <small>{t('Select one or more images to add')}</small>

          <label>{t('Location')}</label>
          <select
            name="location"
            value={property.location || ''}
            onChange={handleChange}
            style={{...styles.select, borderColor: errors?.location ? 'red' : '#ddd'}}
          >
            <option value="">{t('Select Location')}</option>
            {locations.map((loc, idx) => <option key={idx} value={loc}>{t(loc)}</option>)}
            <option value="custom">{t('Other (please specify)')}</option>
          </select>
          {property.location === 'custom' && (
            <input
              type="text"
              name="customLocation"
              value={property.customLocation || ''}
              onChange={handleChange}
              placeholder={t('Enter custom location')}
              style={{...styles.input, marginTop:'10px', borderColor: errors?.customLocation ? 'red' : '#ddd'}}
            />
          )}
          {errors?.location && <div style={styles.error}>{errors.location}</div>}

           {errors.location && <div style={styles.error}>{errors.location}</div>}
       

        <MapPicker
          initialLat={latLng.lat}
          initialLng={latLng.lng}
          onChange={(coords) => setLatLng(coords)} // เมื่อย้ายหมุดจะอัปเดต latLng ใหม่
        />
        <p style={{ fontSize: '12px', color: '#555', marginTop: '5px' }}>
          {t('Latitude')}: {latLng.lat?.toFixed(6) ?? '-'}, {t('Longitude')}: {latLng.lng?.toFixed(6) ?? '-'}
        </p>



          <label>{t('Type')}</label>
          <select
            name="type"
            value={property.type || ''}
            onChange={handleChange}
            style={{...styles.select, borderColor: errors?.type ? 'red' : '#ddd'}}
          >
            <option value="">{t('Select Type')}</option>
            <option value="Condo">{t('Condo')}</option>
            <option value="House">{t('House')}</option>
            <option value="Pool Villa/ Villa">{t('Pool Villa/ Villa')}</option>
            <option value="Land">{t('Land')}</option>
            <option value="Warehouse/Factory/Business">{t('Warehouse / Factory / Business')}</option>
            <option value="Commercial Building">{t('Commercial Building')}</option>
          </select>

          <label>{t('Status')}</label>
          <select
            name="status"
            value={property.status || ''}
            onChange={handleChange}
            style={{...styles.select, borderColor: errors?.status ? 'red' : '#ddd'}}
          >
            <option value="">{t('Select Status')}</option>
            <option value="Buy">{t('Buy')}</option>
            <option value="Rent">{t('Rent')}</option>
            <option value="Sold Out">{t('Sold Out')}</option>
             <option value="Rented">{t('Rented')}</option>
          </select>

          {(property.status === 'Rent' || property.status === 'Rented') && (
            <>
              <label>{t('Rental End Date')}</label>
              <input
                type="date"
                name="rentalEndDate"
                value={
                  property.rentalEndDate 
                    ? new Date(property.rentalEndDate ).toISOString().split('T')[0]
                    : ''
                }
                onChange={handleChange}
                style={{
                  ...styles.input,
                  borderColor: errors?.rentalEndDate  ? 'red' : '#ddd',
                }}
              />
            </>
          )}

          <label>{t('Description')}</label>
          <textarea
            name="description"
            value={property.description || ''}
            onChange={handleChange}
            placeholder={t('Description')}
            style={styles.textarea}
          />

          <input
            type="text"
            name="youtubeurl"
            value={property.youtubeurl || ''}
            onChange={handleChange}
            placeholder={t('YouTube Video URL')}
            style={styles.input}
          />
          <div style={{ fontSize: '12px', color: '#7F8C8D', marginTop: '-10px' }}>
            {t('Add a YouTube video link to showcase your property (optional)')}
          </div>

          <label>{t('Bedrooms')}</label>
          <input type="number" name="bedrooms" value={property.bedrooms || ''} onChange={handleChange} style={styles.input}/>

          <label>{t('Bathrooms')}</label>
          <input type="number" name="bathrooms" value={property.bathrooms || ''} onChange={handleChange} style={styles.input}/>

          <label>{t('Building Area')}</label>
          <input type="text" name="buildingArea" value={property.buildingArea || ''} onChange={handleChange} style={styles.input}/>

        {/*  <label>{t('Land Area')}</label>
          <input type="text" name="landArea" value={property.landArea || ''} onChange={handleChange} style={styles.input}/>
 */}
          <label>{t('Floors')}</label>
          <input type="number" name="floors" value={property.floors || ''} onChange={handleChange} style={styles.input}/>

          <label>{t('Parking')}</label>
          <input type="number" name="parking" value={property.parking || ''} onChange={handleChange} style={styles.input}/>

          <label>{t('Ownership *')}</label>
          <textarea
            name="ownership"
            value={property.ownership || ''}
            onChange={handleChange}
            placeholder={t('Ownership')}
            style={{...styles.textarea, borderColor: errors?.ownership ? 'red' : '#ddd'}}
          />
          <label>{t('Remark')}</label>
          <textarea
            name="remark"
            value={property.remark || ''}
            onChange={handleChange}
            placeholder={t('remark')}
            style={{...styles.textarea, borderColor: errors?.ownership ? 'red' : '#ddd'}}
          />

          <label>{t('Construction Status')}</label>
          <select
            name="constructionStatus"
            value={property.constructionStatus || ''}
            onChange={handleChange}
            style={styles.select}
          >
            <option value="">{t('Select Construction Status')}</option>
            <option value="Under Construction/Under Renovation">{t('Under Construction / Under Renovation')}</option>
            <option value="Ready to Move In">{t('Ready to Move In')}</option>
            <option value="Pre-sale / Off-plan">{t('Pre-sale / Off-plan')}</option>
            <option value="As is house">{t('As is house')}</option>
          </select>

          <label>
            <input type="checkbox" name="furnished" checked={property.furnished || false} onChange={handleChange}/>
            {t('Furnished')}
          </label>

          <label>
            <input type="checkbox" name="featured" checked={property.featured || false} onChange={handleChange}/>
            {t('Hot Deal')}
          </label>

          <button type="submit" style={styles.button}>{t('Save Changes')}</button>
        </form>

        <button onClick={() => navigate('/dashboardadmin')} style={styles.backButton}>
          {t('Back to Dashboard')}
        </button>
      </div>
      <Footer />
    </div>
  );
};
const styles = {
  pageContainer: {
   display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '20px',
    paddingTop: '0px',
    paddingBottom: '0px',
    minHeight: '100vh',
  },
  container: {
    flex: 1,
    width: '100%',
    maxWidth: '900px',
    margin: '0 auto',
    padding: '20px',
    boxSizing: 'border-box',
  },
  heading: {
    fontSize: '28px',
    fontWeight: 'bold',
    marginBottom: '20px',
    color: '#333',
    textAlign: 'center',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
    width: '100%',
  },
  input: {
    padding: '12px',
    fontSize: '16px',
    borderRadius: '8px',
    border: '1px solid #ddd',
    backgroundColor: '#fff',
    boxSizing: 'border-box',
  },
  select: {
    padding: '12px',
    fontSize: '16px',
    borderRadius: '8px',
    border: '1px solid #ddd',
    backgroundColor: '#fff',
    boxSizing: 'border-box',
  },
  textarea: {
    padding: '12px',
    fontSize: '16px',
    borderRadius: '8px',
    border: '1px solid #ddd',
    backgroundColor: '#fff',
    height: '100px',
    boxSizing: 'border-box',
  },
  button: {
    padding: '12px 20px',
    backgroundColor: '#2980B9',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '16px',
  },
  backButton: {
    marginTop: '20px',
    padding: '12px 20px',
    backgroundColor: '#3498db',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '16px',
  },
  propertyInfo: {
    fontSize: '14px',
    color: '#7F8C8D',
    marginBottom: '10px',
  },
  error: {
    color: 'red',
    fontSize: '12px',
    marginTop: '5px',
  },
  guideText: {
    fontSize: '12px',
    color: '#7F8C8D',
    marginTop: '5px',
    fontStyle: 'italic',
  },
};

export default EditProperty;
